// internationalization
import { useTranslation } from 'react-i18next';

// shared components
import InsetDrawer from '@/components/ui/drawer/InsetDrawer';

// feature-components
import EnergyAnalyzerFilterInput from '@/features/energyxplorer/components/analysis/EnergyAnalyzerFilterInput';

const TreeGraphFilterInput = ({ open, onClose, selectedEnergyGroup }) => {
  const { t } = useTranslation();

  return (
    <InsetDrawer
      open={open}
      onClose={onClose}
      title={t('energyxplorer:tooltips.filterData')}
      width={600}
    >
      <EnergyAnalyzerFilterInput
        scope="tree"
        selectedEnergyGroup={selectedEnergyGroup}
        startHour={selectedEnergyGroup?.options?.workingDayStart}
        endHour={selectedEnergyGroup?.options?.workingDayEnd}
        setComparisonFilters={() => {}}
      />
    </InsetDrawer>
  );
};

export default TreeGraphFilterInput;
